import React from "../_snowpack/pkg/react.js";
import Component from "./editable-component.js";
import Header from "./header.js";
import Footer from "./footer.js";
import FooterReduced from "./footer-reduced.js";
import {Global} from "../_snowpack/pkg/@emotion/react.js";
import {GlobalStyles} from "./theme.js";
export default function Module(props) {
  const {content, url, locale, locales, sessionCart, ...rest} = props;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Global, {
    styles: GlobalStyles
  }), /* @__PURE__ */ React.createElement(Component, {
    ...content
  }, /* @__PURE__ */ React.createElement(ModuleComponent, {
    content,
    sessionCart,
    url,
    locale,
    locales,
    ...rest
  })));
}
function ModuleComponent(props) {
  const {
    url,
    locale,
    locales,
    sessionCart,
    content,
    languageSwitch,
    ...rest
  } = props;
  const {component} = content;
  if (content.component === "header_menu") {
    const menus = {header: content};
    return /* @__PURE__ */ React.createElement(Header, {
      menus,
      locale,
      locales,
      url,
      sessionCart,
      languageSwitch
    });
  }
  if (content.component === "footer_menu") {
    const menus = {footer: content};
    return /* @__PURE__ */ React.createElement(Footer, {
      menus
    });
  }
  if (content.component === "account_menu_footer") {
    const menus = {footer: content};
    return /* @__PURE__ */ React.createElement(FooterReduced, {
      menus
    });
  }
  return null;
}
